import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#1D5BE5',
                conservative:"#54bf56",
                moderate:"#f1ad1b",
                aggressive:"#f15d1b",
                colorScale1:"#68E58A",
                colorScale2:"#C1EF6B",
                colorScale3:"#FFF500",
                colorScale4:"#FFDA3E",
                colorScale5:"#FFB045",
                colorScale6:"#F04141",
            },
        },
    },
    icons: {
        iconfont: 'mdiSvg',
    }
});
